import React, { useContext } from 'react'
import { GeneralSelector } from '@pinflag/pinflag-ui-kit'
import { paymentLogos } from '../../constants/payment-logos'
import { PAYMENT_METHOD_TRANSLATION } from '../../constants/translation'
import { DataContext } from '../../context/DataContext'
import { useNativePayment } from '../../hook/payment/useNativePayment'
import PropTypes from 'prop-types'

const NativePaymentMethodSelection = ({ scrapperClient }) => {
  const { handlePaymentMethod, selectedNativePaymentMethod } =
    useNativePayment({ scrapperClient })

  const { companyInfo, cmsPaymentMethods } =
    useContext(DataContext)

  const { companyName, primaryColor } = companyInfo

  const getCustomSubtitlePaymentMethodSelector = (method) => {
    if (['Depósito Bancario', 'Transferencia Bancaria', 'Transferencia'].includes(method.code)) {
      return 'Te daremos los datos bancarios en el próximo paso'
    }
    if (companyName === 'Tost' && method.code === 'Mercado Pago') {
      return 'Desde $29.990, ahorra $10.000 con Copec Pay.'
    }
    return undefined
  }

  return (
    <div className="flex flex-col px-4 gap-y-3 my-[10px] mx-[27px]">
      <div className="flex flex-col md:max-h-[260px] md:h-full overflow-y-auto div-payment-methods">
        {cmsPaymentMethods &&
          cmsPaymentMethods.map((method) => (
            <GeneralSelector
              key={method.title}
              color={primaryColor}
              title={
                (PAYMENT_METHOD_TRANSLATION[companyName] &&
                  PAYMENT_METHOD_TRANSLATION[companyName][method.title]) ||
                method.title
              }
              onClick={() => handlePaymentMethod(method)}
              isSelected={selectedNativePaymentMethod === method.code}
              image={paymentLogos(companyName)[method.code]?.logo}
              logoWidth={paymentLogos(companyName)[method.code]?.width}
              subtitle={getCustomSubtitlePaymentMethodSelector(method)}
              classNameContainer="mb-2"
            />
          ))}
      </div>
    </div>
  )
}

NativePaymentMethodSelection.propTypes = {
  scrapperClient: PropTypes.string
}

export default NativePaymentMethodSelection
